import { useCallback } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useViewActions } from '@renderer/overlay/Sidepanel/view-atoms'
import { useSidebarSearchModel, useSidebarSearchQuery, useSidebarSearchSkillId } from './sidebar-search-atoms'
import { useSearchModel } from './sidebar-search-models'
import { useSidebarSlashSkills } from './use-sidebar-slash-skills'

/**
 * Opens a new chat that sends the search text straight away, to the picked model, with the `/` skill it names
 * and what the plus attached. Clears the search so Home is back to normal behind it.
 */
export function useStartChatAboutQuery() {
  const { openView } = useViewActions()
  const [query, setQuery] = useSidebarSearchQuery()
  const [, setPickedSkillId] = useSidebarSearchSkillId()
  const [modelKey] = useSidebarSearchModel()
  const model = useSearchModel(modelKey)
  const { pickedSkill } = useSidebarSlashSkills()

  return useCallback(() => {
    const text = query.trim()
    if (!text) {
      return
    }
    openView(
      'chat',
      {
        isNew: true,
        draftId: uuidv4(),
        initialPrompt: model ? `@${model.label} ${text}` : text,
        initialPromptModelId: model?.id,
        initialPromptSkillId: pickedSkill?.id,
        sendsComposerAttachments: true,
      },
      { sourceLabel: 'Search' },
    )
    setQuery('')
    setPickedSkillId(null)
  }, [openView, query, setQuery, setPickedSkillId, model, pickedSkill])
}
